import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './api';
import type { VedlikeholdKategori } from '@/types/api';

export const kategorierKey = ['kategorier'] as const;

// Public list of Generelt vedlikehold kategorier — both the add-entry modal
// (dropdown of options) and the kategori-management modal consume this.
// entriesCount drives the disabled-delete-when-non-empty UX.
export function useKategorier() {
  return useQuery({
    queryKey: kategorierKey,
    queryFn: async () => (await api.get<{ data: VedlikeholdKategori[] }>('/kategorier')).data,
  });
}

export function useCreateKategori() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name: string) => api.post<{ data: VedlikeholdKategori }>('/kategorier', { name }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: kategorierKey });
    },
  });
}

export function useRenameKategori(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (name: string) =>
      api.patch<{ data: VedlikeholdKategori }>(`/kategorier/${id}`, { name }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: kategorierKey });
    },
  });
}

export function useDeleteKategori() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/kategorier/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: kategorierKey });
    },
  });
}
